<script>
import {required} from "vuelidate/lib/validators";
import appConfig from "@/app.config";
import Vue from "vue";

import {VueRecaptcha} from "vue-recaptcha";
import LetterCube from "@/components/LetterCube";

/**
 * Login component
 */
export default {
  page: {
    title: "Đăng nhập",
    meta: [{name: "description", content: appConfig.description}],
  },
  // eslint-disable-next-line vue/no-unused-components
  components: {VueRecaptcha, LetterCube},
  validations: {
    model: {
      userName: {
        required,
      },
      password: {
        required
      }
    }
  },
  data() {
    return {
      capcha: null,
      email: "admin@themesbrand.com",
      password: "123456",
      submitted: false,
      authError: null,
      tryingToLogIn: false,
      isAuthError: false,
      modelAuth: {
        isAuthError: false,
        message: null
      },
      model: {
        userName: "",
        password: ""
      },
      vanThuTruong: "D2570530.000453",
      lanhDaoPHC: "D2570410.000554",
      acceptAccount: ["D2570330.000183", 'D2570510.000823'],
      passwordFieldType: "password",
    };
  },
  computed: {
    isVanThu() {
      return this.vanThuTruong == this.model.userName || this.lanhDaoPHC == this.model.userName || this.acceptAccount.includes(this.model.userName);
    }
  },
  methods: {
    switchVisibility() {
      this.passwordFieldType = this.passwordFieldType === "password" ? "text" : "password";
    },
    submit(response) {
      this.capcha = response;
    },
    async Login(e) {
      e.preventDefault();
      // if (!this.capcha && process.env.VUE_APP_ENV != 'development' && !this.isVanThu) {
      //   this.modelAuth.isAuthError = true;
      //   this.modelAuth.message = "Xác nhận đã nhập mã captcha";
      //   return;
      // }
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        let loader = this.$loading.show({
          container: this.$refs.formContainer,
        }, {
          default: this.$createElement(LetterCube),
        });
        // await setTimeout(function () {
        //  }, 5000);
        await this.$store.dispatch("authStore/login", this.model).then(async (res) => {
          if (res.resultCode === 'SUCCESS') {
            await new Promise(resolve => setTimeout(resolve, 1000));
            localStorage.setItem('auth-user', JSON.stringify(res.data));
            localStorage.setItem("user-token", JSON.stringify(res.data.token));

            if (res.data.user) {
              if (res.data.user.menuItems) {
                localStorage.setItem("menuItems", JSON.stringify(res.data.user.menuItems));
              }
            }
            Vue.prototype.$auth_token = res.data.token;
            this.showModal = false;
            this.model = {};
            this.modelAuth.isAuthError = false;
            window.location.href = '/'
          } else {
            if (res.code == 400) {
              this.modelAuth.isAuthError = true;
              this.modelAuth.message = "Lỗi! Hãy kiểm tra kết nối mạng!";
            } else {
              this.modelAuth.isAuthError = true;
              this.modelAuth.message = res.resultString;
            }
            loader.hide();
          }

        })
            .finally(() => {
              loader.hide();
            });
      }
      this.submitted = false;
    },
  }
};
</script>

<template>
  <div class="account-pages pages-login">
    <div class="container h-100">
      <div class="row justify-content-center align-content-center h-100">
        <div class="col-md-12 col-lg-10">
          <div class="card card-login overflow-hidden login-box">
            <div class="row">
              <div class="col-12 col-md-6 login-box-left">
                <div class="text-primary text-center">
                  <a href="/" class="logo-login mb-2">
                    <img
                        src="@/assets/images/DTHU.png"
                        alt="logo"
                        class="d-inline-block"
                    />
                  </a>
                  <h5 class="title-login">
                    <p class="me-1">Hệ thống</p>
                    <p>DOffice - DThU</p>
                  </h5>
                  <p class="sub-title">Hệ thống hành chính số</p>

                </div>
              </div>
              <div class="col-12 col-md-6 login-box-right">
                <div class="p-md-5 p-3">
                  <h2 class="text-white sub-title-login">Đăng nhập</h2>
                  <b-alert
                      v-model="modelAuth.isAuthError"
                      variant="danger"
                      class="mt-4 class"
                      dismissible
                  >
                    {{ modelAuth.message }}
                  </b-alert>
                  <b-form
                      @submit.prevent="Login" ref="formContainer"
                      class="form-horizontal mt-4"
                  >
                    <b-form-group
                        id="input-group-1"
                        label="Tài khoản"
                        label-for="input-1"
                        class="mb-3 text-white"
                        label-class="form-label"
                    >
                      <b-form-input
                          id="input-1"
                          v-model="model.userName"
                          type="text"
                          placeholder="Nhập tài khoản"
                          :class="{ 'is-invalid': submitted && $v.model.userName.$error }"
                          class="username"
                      ></b-form-input>
                      <div
                          v-if="submitted && $v.model.userName.$error"
                          class="invalid-feedback"
                      >
                        <span v-if="!$v.model.userName.required">Tài khoản không được trống.</span>
                      </div>
                    </b-form-group>

                    <b-form-group
                        id="input-group-2"
                        label="Mật khẩu"
                        label-for="input-2"
                        class="mb-3 text-white"
                        label-class="form-label"
                    >
                      <div class="position-relative">
                        <b-form-input
                            id="input-2"
                            v-model="model.password"
                            :type="passwordFieldType"
                            placeholder="Nhập mật khẩu"
                            :class="{ 'is-invalid': submitted && $v.model.password.$error }"
                            class="password"
                        ></b-form-input>
                        <div class="input-group-prepend">
                          <a @click="switchVisibility">
                            <i v-if="passwordFieldType == 'text'" class="mdi mdi-eye mdi-18px"></i>
                            <i v-else class="mdi mdi-eye-off mdi-18px"></i>
                          </a>
                        </div>
                      </div>

                      <div
                          v-if="submitted && !$v.model.password.required"
                          class="invalid-feedback"
                      >
                        Mật khẩu không được trống.
                      </div>
                    </b-form-group>
                    <div class="form-group row">
<!--                      <div class="my-2 d-flex justify-content-center align-items-center capcha-box">-->
<!--                        <vue-recaptcha v-if="!isVanThu" @verify="submit"-->
<!--                                       sitekey="6LcnfWwhAAAAAIW-zBI9Cg5s5LNcYepeevhybx9o"></vue-recaptcha>-->
<!--                      </div>-->
                      <div class="col-sm-12 text-end">
                        <b-button type="submit" class="w-100 text-uppercase fw-bold  btn-login"
                                  style="background-color: #00568C"
                        > Đăng nhập
                        </b-button
                        >
                      </div>
                    </div>
                  </b-form>
                </div>
                <p class="mb-0 text-center text-white">
                  ©
                  {{ new Date().getFullYear() }}
                  - Trường Đại học Đồng Tháp
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.pages-login {
  position: fixed;
  width: 100%;
  overflow-y: hidden;
  overflow: hidden;

  @media only screen and (max-width: 768px) {
    overflow-y: inherit;
    overflow: inherit;
  }

  & .card-login {
    box-shadow: 0px 0px 13px 0px rgb(3 3 58 / 50%);
  }

  & .logo-login > img {
    width: 100px;
    height: 100px;
    @media only screen and (max-width: 425px) {
      width: 50px;
      height: 50px;
    }
  }


}

.pages-login {
  background-image: linear-gradient(90deg, rgba(18, 26, 70, 0.3), rgba(29, 107, 184, 0.3)),
  url("~@/assets/images/bg-login-2.png");
  background-repeat: no-repeat;
  background-size: cover;
  height: 100vh;
  overflow-x: hidden;

  & .login-box {
    background: rgba(18, 26, 70, 0.8) !important;
    height: 100% !important;
    padding: 50px 0;
    @media (max-width: 425px) {
      padding: 50px 0;
    }

    & .login-box-left {
      display: flex;
      justify-content: center;
      align-items: center;

      & .title-login {
        display: flex;
        text-transform: uppercase;
        justify-content: center;
        //text-shadow: 2px 2px 1px #fff;

        @media (max-width: 768px) {
          font-size: 24px;
          flex-wrap: wrap;
        }

        @media (max-width: 425px) {
          margin-bottom: 0px;
        }

        & p {
          font-size: 32px;
          font-weight: 900;
          color: #fff !important;
          padding: 50px 0px 20px 0px;
          margin-bottom: 0px;

          -webkit-text-stroke: 1px #66f0fd;
          -webkit-text-fill-color: white;
          -webkit-animation: fill 0.5s infinite alternate;

          @media (max-width: 1200px) {
            font-size: 24px;
            padding: 20px 0px 10px 0px;
          }
          @media (max-width: 936px) {
            font-size: 24px;
          }
          @media (max-width: 768px) {
            font-size: 28px;
            padding: 10px 0px 0px 0px;
          }
          @media (max-width: 425px) {
            font-size: 16px;
            padding: 10px 0px 5px 0px;
          }
          @media (max-width: 375px) {

          }
          @media (max-width: 320px) {

          }
        }


      }

      & .sub-title {
        color: #fff !important;
        font-size: 18px;
        @media (max-width: 425px) {
          font-size: 14px;
          margin-bottom: 0px;
        }
      }

      & .capcha-box {
        & div {
          & div {
            @media (max-width: 320px) {
              width: 240px !important;
            }

            & iframe {
              @media (max-width: 320px) {
                width: 100%;
              }

            }
          }
        }
      }

    }

    & .login-box-right {
      & .sub-title-login {
        position: relative;
        margin-bottom: 50px;
        @media (max-width: 425px) {
          font-size: 16px;
          margin-bottom: 20px;
        }
        &:before {
          content: "";
          display: block;
          width: 25%;
          height: 2px;
          background: #fff;
          position: absolute;
          bottom: -20px;
          @media (max-width: 425px) {
            width: 15%;
            height: 1px;
            bottom: -10px;
          }
        }

      }

      & .form-label{
        font-size: 14px;
        font-weight: normal;
      }

      & .username,
      & .password {
        padding: 15px;
        background-color: transparent !important;
        color: #fff !important;
        @media (max-width: 425px){
          padding: 10px;
        }

        &:focus {
          border: 1px solid #fff !important;

        }
      }

      & .username {


      }

      & .password {
        position: relative;
      }

      & .input-group-prepend {
        position: absolute;
        top: 0;
        right: 0;
        transform: translate(-10px, 13px);

        & .btn {

        }
      }

      & .btn-login {
        padding: 15px;
        background: #2F93E0 !important;
        @media (max-width: 425px) {
          padding: 10px;
        }
      }
    }
  }
}

.rc-anchor-content {
  @media (max-width: 375px) {
    display: none !important;
  }
}


</style>
